import arrow_next from "../../../../../../assets/images/arrow-next.svg";
import arrow_prev from "../../../../../../assets/images/arrow-prev.svg";
import calenderTwo from "../../../../../../assets/images/calender2.svg";
import closeSvg from "../../../../../../assets/svg/POSTER/close.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import zIndex from "@material-ui/core/styles/zIndex";

export const DateNavigator = ({
    locationState,
    prevWeekFunc,
    startDate,
    nextWeekFunc,
    today,
    viewType,
    weeklyView,
    fetchLinearData,
    setViewFunction
}) => {
    const pickDate = (e) => {
        const date = new Date(e);
        // Format as YYYY-MM-DD in local time
        const formattedDate = date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0');
        
        const newStartDate = new Date(formattedDate);
        newStartDate.setDate(newStartDate.getDate() - 1);
        const start = newStartDate.toISOString().split("T")[0];

        const newEndDate = new Date(formattedDate);
        newEndDate.setDate(newEndDate.getDate() + 6);
        const end = newEndDate.toISOString().split("T")[0];

        fetchLinearData(start, end, 7);
    }
    return (
        <div className={`left-side ${locationState?.state?.channelAssembly === "EXTERNAL" || weeklyView ? "d-flex justify-content-between align-items-center w-100": ""}`}>
            <h3 style={{color: "#BFBFBF", margin: "8px 0px 16px 0px"}}>{locationState?.state?.channelName}</h3>
            <div class="d-flex gap-3 align-items-center">
                <DatePicker
                    onChange={(e) => pickDate(e)}
                    customInput={
                        <a
                          className="btn btn-revert p-0"
                          style={{ width: '2.25rem', height: '2.25rem', background: '#444649' }}
                        >
                          <img src={calenderTwo} width={18} alt="calendar icon" />
                        </a>
                    }
                />
            {/* <a className='btn btn-revert p-0' style={{width: '2.25rem', height:'2.25rem', background: "#444649"}}><img src={calenderTwo} width={18}/></a> */}
                <div class="d-flex align-items-center text-white px-1 rounded justify-content-between" style={{background: "#FFFFFF0A", height: "2.5rem", width: "15.313rem"}}>
                    <a className="btn mx-1 p-0" onClick={(e) => prevWeekFunc(e)} style={{ height: "1.5rem", width: "1.5rem", background: "#444649" }}><img src={arrow_prev} width={5} style={{ filter: "invert(1)" }}/></a>
                    <span className="mx-1">
                        {
                            `
                            ${viewType === "expandView"? new Date(locationState?.state?.panelDate).toLocaleDateString("en-GB") : new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1))
                                .toLocaleDateString("en-GB")} 
                            ${viewType === "expandView" ? '' : '- '+new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 7))
                                .toLocaleDateString("en-GB")}
                            `
                        }
                    </span>
                    <a className="btn mx-1 p-0" onClick={(e) => nextWeekFunc(e)} style={{ height: "1.5rem", width: "1.5rem", background: "#444649" }}><img src={arrow_next} width={5} style={{ filter: "invert(1)" }}/></a>
                </div>
                <button class="btn btn-secondary my-auto text-white radius-8x" style={{height: "2rem", width: "8.625rem"}} onClick={today}>Today</button>
                {
                    weeklyView && 
                    <a className='btn btn-revert p-0' onClick={setViewFunction} style={{width: '2.25rem', height:'2.25rem', background: "#444649"}}><img src={closeSvg} width={20}/></a>
                }
            </div>
        </div>
    )
}